import { Add } from "@mui/icons-material";
import { Fab, Tooltip } from "@mui/material";

export const AddButton = (props) => {
  const { toolTipText, onAddClick } = props;
  return (
    <Tooltip title={toolTipText || ""}>
      <Fab
        color="primary"
        size="medium"
        sx={{
          position: "fixed",
          bottom: 40,
          right: 40,
          zIndex: 1000
        }}
        onClick={onAddClick}>
        <Add />
      </Fab>
    </Tooltip>
  );
};
